import { render, staticRenderFns } from "./indexScoreManage-h.vue?vue&type=template&id=9e75ea50&scoped=true&"
import script from "./indexScoreManage-h.vue?vue&type=script&lang=js&"
export * from "./indexScoreManage-h.vue?vue&type=script&lang=js&"
import style0 from "./indexScoreManage-h.vue?vue&type=style&index=0&id=9e75ea50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e75ea50",
  null
  
)

export default component.exports